import { defineComponent as p, computed as u } from "vue";
import { processMediaItem as v } from "@i22/rocket";
import { getMainImageFromOffer as h } from "./td-longtail-vue-components89.js";
import W from "./td-longtail-vue-components8.js";
import y from "./td-longtail-vue-components9.js";
const F = /* @__PURE__ */ p({
  __name: "goliath-image-element",
  props: {
    imageClass: { default: void 0 },
    imageStyle: { default: void 0 },
    format: { default: void 0 },
    doNotConvert: { type: Boolean },
    preload: { type: Boolean },
    image: { default: void 0 },
    offer: { default: void 0 },
    alt: { default: void 0 },
    productName: { default: void 0 },
    xsWidth: { default: "medium" },
    smWidth: { default: "large" },
    lazy: { type: Boolean },
    renderWithoutFigure: { type: Boolean },
    sizes: { default: void 0 }
  },
  emits: ["image-error"],
  setup(f, { expose: c }) {
    const e = f, m = (t, s) => {
      const r = {};
      return Object.keys(t).forEach((d) => {
        s.includes(d) || (r[d] = t[d]);
      }), r;
    }, i = (t) => {
      if (t)
        return t.replace(/\/public\//, "/product-images/");
    }, a = (t, s = "medium") => {
      let r = t;
      switch (t.mediaId && !t.medium && (r = v(t)), s) {
        case "small":
          return i(r.small);
        case "medium":
          return i(r.medium);
        default:
          return i(r.large);
      }
    }, g = u(() => m(e, [
      "offer",
      "src",
      "renderWithoutFigure",
      "image",
      "xsWidth",
      "smWidth"
    ])), o = u(() => {
      if (e.image) return e.image;
      if (e.offer) return h(e.offer);
    }), l = u(() => {
      if (o.value)
        return e.sizes ? a(o.value, "large") : a(o.value, e.xsWidth);
    }), n = u(() => {
      if (!(!o.value || e.sizes))
        return a(o.value, e.smWidth);
    });
    return c({
      src: l,
      srcSm: n
    }), { __sfc: !0, getFiltersProps: m, getUrl: i, getImagesByWidth: a, props: e, passThroughProps: g, parsedImage: o, src: l, srcSm: n, ImageElement: W, PictureElement: y };
  }
});
export {
  F as default
};
